import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import * as NotebookSecretActions from './notebook-secret.actions';
import { ISecret } from '@mode/notebooks/contract';
import { toSecretKeys } from 'libs/shared/data-access-webapp/src/lib/data-mappers/secret-data-mappers';

export const notebookSecretFeatureKey = 'notebookSecret';

export interface NotebookSecretState {
  secrets: ISecret[];
  loadSecretError: HttpErrorResponse | null;
}

export const notebookSecretInitialState: NotebookSecretState = {
  secrets: [],
  loadSecretError: null,
};

export const notebookSecretsReducer = createReducer(
  notebookSecretInitialState.secrets,
  on(NotebookSecretActions.loadSecret, (state, action) => state),
  on(NotebookSecretActions.loadSecretSuccess, (state, action) => toSecretKeys(action)),
  on(NotebookSecretActions.loadSecretFail, (state, action) => state),

  on(NotebookSecretActions.createSecret, (state) => state),
  on(NotebookSecretActions.createSecretSuccess, (state, action) => state),
  on(NotebookSecretActions.createSecretFail, (state, action) => state),

  on(NotebookSecretActions.editSecret, (state) => state),
  on(NotebookSecretActions.editSecretSuccess, (state, action) => state),
  on(NotebookSecretActions.editSecretFail, (state, action) => state),

  on(NotebookSecretActions.deleteSecret, (state) => state),
  on(NotebookSecretActions.deleteSecretSuccess, (state, action) => state),
  on(NotebookSecretActions.deleteSecretFail, (state, action) => state)
);

export const loadSecretsErrorReducer = createReducer(
  notebookSecretInitialState.loadSecretError,
  on(NotebookSecretActions.loadSecret, (state, action) => state),
  on(NotebookSecretActions.loadSecretFail, (state, action) => state)
);

export const reducer = {
  secrets: notebookSecretsReducer,
  loadSecretError: loadSecretsErrorReducer,
};
